import LeadQueueIndex from '@/views/LeadQueue/LeadQueueIndex.vue';
import LeadAmortizations from '@/views/Leads/Amortization/LeadAmortizationIndex.vue';
import PerformanceIndex from '@/views/Performance/PerformanceIndex.vue';
import LeadJourneyMethods from '@/views/Performance/LeadJourneyMethods.vue';
import LeadJourneyApiCalls from '@/views/Performance/LeadJourneyApiCalls.vue';
import DevMenu from '@/views/Dev/DevMenu.vue';
import DeveloperTools from '@/views/Dev/DeveloperTools.vue';
import WaterfallTestIndex from '@/views/Waterfall/WaterfallTestIndex.vue';
import SupportWaterfallTestIndex from '@/views/Tickets/TestSuite/WaterfallTestIndex.vue';
import ShortFormLeadIndex from '@/views/TestSuite/ShortFormLead/ShortFormLeadIndex.vue';

export default [
  {
    path: 'waterfall/test',
    name: 'waterfall-test',
    component: WaterfallTestIndex,
    meta: {
      title: 'Waterfall Test',
      permission: 'view waterfall-test',
    },
  },
  {
    path: 'support/test',
    name: 'support-test-suite',
    component: SupportWaterfallTestIndex,
    meta: {
      title: 'Tbot Waterfall Test',
      permission: 'view support-test-suite',
    },
  },
  {
    path: 'test-suite/short-form-lead',
    name: 'test-suite-short-form-lead',
    component: ShortFormLeadIndex,
    meta: {
      title: 'Test Suite Short Form Lead',
      permission: 'view support-test-suite',
    },
  },
  {
    path: 'lead-queue-index',
    name: 'lead-queue-index',
    component: LeadQueueIndex,
    meta: {
      title: 'Lead Queue',
      permission: 'view queue',
    },
  },
  {
    path: 'developer-tools',
    name: 'developer-tools',
    component: DeveloperTools,
    meta: {
      title: 'Developer Tools',
      permission: 'view dev-menu',
    },
    children: [
      {
        path: 'lead-queue',
        name: 'lead-queue',
        component: LeadQueueIndex,
        meta: {
          title: 'Lead Queue',
          permission: 'view queue',
        },
      },
      {
        path: 'performance',
        name: 'performance',
        component: PerformanceIndex,
        meta: {
          title: 'Performance',
          permission: 'view performance',
        },
        children: [
          {
            path: 'lead-journey-methods',
            name: 'lead-journey-methods',
            component: LeadJourneyMethods,
            meta: {
              title: 'Lead Journey Methods',
              permission: 'view performance::lead-journey-methods',
            },
          },
          {
            path: 'lead-journey-api-calls',
            name: 'lead-journey-api-calls',
            component: LeadJourneyApiCalls,
            meta: {
              title: 'Lead Journey Api Calls',
              permission: 'view performance::lead-journey-api-calls',
            },
          },
        ],
      },
      {
        path: 'amortization',
        name: 'lead-amortizations',
        component: LeadAmortizations,
        meta: {
          title: 'Amortization',
          permission: 'view lead::amortization',
        },
      },
    ],
  },
  {
    path: 'dev',
    name: 'dev-menu',
    component: DevMenu,
    meta: {
      title: 'Dev Menu',
      permission: 'view dev-menu',
    },
  },
];
